import { useEffect, useState } from 'react';
import { defaultAvatar, isPlayerAvatar } from '@brainfart/shared';
import { getStoredDisplayName, saveDisplayName } from './displayName';

// One player identity (name + avatar) used by every mode: duels, the Daily
// board, multiplayer rooms and Practice. Set once, edit from the profile chip.

const AVATAR_KEY = 'bf_avatar';

export interface Identity {
  name: string;
  avatar: string;
}

export function getAvatar(name: string = getStoredDisplayName()): string {
  try {
    const stored = localStorage.getItem(AVATAR_KEY);
    if (isPlayerAvatar(stored)) return stored;
  } catch { /* ignore */ }
  return defaultAvatar(name || 'player');
}

export function getIdentity(): Identity {
  const name = getStoredDisplayName();
  return { name, avatar: getAvatar(name) };
}

export function hasProfile(): boolean {
  return getStoredDisplayName().trim().length > 0;
}

const listeners = new Set<() => void>();

export function saveIdentity(name: string, avatar: string) {
  saveDisplayName(name);
  try {
    if (isPlayerAvatar(avatar)) localStorage.setItem(AVATAR_KEY, avatar);
  } catch { /* ignore */ }
  listeners.forEach(l => l());
}

// Re-renders when the profile is edited anywhere.
export function useIdentity(): Identity {
  const [identity, setIdentity] = useState(getIdentity);
  useEffect(() => {
    const l = () => setIdentity(getIdentity());
    listeners.add(l);
    return () => { listeners.delete(l); };
  }, []);
  return identity;
}
